
export default function (fn, ...args) {
  return [fn, ...args];
}
